// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard[data-v-43340258] {\n  min-height: calc(100vh - 90px);\n  overflow-y: hidden !important;\n}\n#app > div.app-content[data-v-43340258] {\n  overflow-y: auto !important;\n}", ""]);
// Exports
module.exports = exports;
